import { IDraft } from '@aca-new/app/pages/book/shared/models/interfaces/draft.interface';
import { QimaNullableType } from '@aca-new/app/shared/models/types/qima.type';
import { HttpService } from '@aca-new/app/shared/services/http-services/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BookFromPreviousOrderService {
  public constructor(private readonly _httpService: HttpService) {}

  public createDraftFromPreviousOrder$(url: string): Observable<QimaNullableType<IDraft>> {
    return this._httpService.httpClient
      .post<QimaNullableType<IDraft>>(`${url}`, {
        observe: 'body',
      })
      .pipe(map((response: QimaNullableType<IDraft>): QimaNullableType<IDraft> => response));
  }
}
